"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataPxtTelemetryEvents = void 0;
class DataPxtTelemetryEvents {
    constructor(eventsWithTriggerResourceNames) {
        this.eventsWithTriggerResourceNames = eventsWithTriggerResourceNames;
        this.eventAttribute = "data-pxt-telemetry-events";
        this.eventAttributeValue = this.serializePayload();
    }
    getEventAttribute() {
        return this.eventAttribute;
    }
    getEventAttributeValue() {
        return this.eventAttributeValue;
    }
    serializePayload() {
        return this.encodeToBase64(JSON.stringify(this.eventsWithTriggerResourceNames));
    }
    toBinary(data) {
        // https://developer.mozilla.org/en-US/docs/Web/API/btoa#unicode_strings
        const codeUnits = Uint16Array.from({ length: data.length }, (_, index) => data.charCodeAt(index));
        const charCodes = new Uint8Array(codeUnits.buffer);
        let result = "";
        charCodes.forEach((char) => {
            result += String.fromCharCode(char);
        });
        return result;
    }
    encodeToBase64(data) {
        return btoa(this.toBinary(data));
    }
}
exports.DataPxtTelemetryEvents = DataPxtTelemetryEvents;
